// extracted by mini-css-extract-plugin
export var card = "_ma-0";
export var content = "_ma-2";
export var details = "_ma-3";
export var icon = "_ma-1";
export var iconBlue = "_ma-5";
export var iconBrand = "_ma-4";
export var iconGrayBlue = "_ma-6";
export var iconGreen = "_ma-7";
export var iconIndigo = "_ma-8";
export var iconOrange = "_ma-9";
export var iconPurple = "_ma-a";
export var iconRed = "_ma-b";
export var iconWarning = "_ma-c";